module.exports = __webpack_public_path__ + "svg_80x80/falcon.80d0b0.svg";